// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5f6e0be7","239":"f21e5f3d","557":"374510bc","607":"299f2db9","732":"5faa8717","762":"73bc3ed9"}[chunkId] + ".chunk.js";
};